import { useUnit } from "effector-react"
import { t } from "i18next"
import { $callcenterService, $userService } from "@callcenter/effector-services"

export const useAccountInfo = () => {
  const callcenterSettings = useUnit($callcenterService.$settings)
  const userInfo = useUnit($userService.$userSettings)

  return [
    {
      label: t("userProfile_userProfileSidePanel_accountInformationLabel_contactCenterLabel"),
      value: callcenterSettings.name
    },
    {
      label: t("userProfile_userProfileSidePanel_accountInformationLabel_callerIDLabel"),
      value: userInfo.caller_id || t("userProfile_userProfileSidePanel_accountInformationLabel_notAssignedLabel")
    },
    {
      label: t("userProfile_userProfileSidePanel_accountInformationLabel_extensionLabel"),
      value: userInfo.extension || t("userProfile_userProfileSidePanel_accountInformationLabel_notAssignedLabel")
    }
  ]
}
